<template>
  <loader v-if="isLoader" />
  <div class="container-fluid" v-if="!isLoader">
    <div class="dashboard-image">
      <img src="@/assets/images/dashchart.svg" alt="#" />
    </div>

    <!-- Header and Chart Row -->
    <div class="row">
      <!-- Header -->
      <div class="col-12 header">
        <div class="row">
          <div class="col-lg-3 logo-container">
              <a href="/#/" v-if="false">
            <img
              src="@/assets/images/logo-lg-light.svg"
              alt="#"
              v-if="theme == 'light'"
            />
            </a>
             <a href="/#/" v-if="false">
            <img
              src="@/assets/images/logo-lg-medium.svg"
              alt="#"
              v-if="theme == 'medium'"
            />
            </a>
             <a href="/#/" v-if="false">
            <img
              src="@/assets/images/logo-lg-dark.svg"
              alt="#"
              v-if="theme == 'dark'"
            />
            </a>
          </div>
          <div class="col-lg-6 dash-heading-container">
            <h1 v-if="lang == 'ar'">نظام إدارة المشاريع</h1>
            <h1 v-if="lang == 'en'">Enterprise Project Management System</h1>
            <div class="line"></div>
          </div>
          <div class="col-lg-3 custom-dropdown-container">
            <div class="arrowlogo">
               <img 
              src="@/assets/images/arrow-h-dark.png"
              alt="#"
              v-if="theme == 'dark'"/>
              <img 
              src="@/assets/images/arrow-h-medium.png"
              alt="#"
              v-if="theme == 'medium'"/>
              <img 
              src="@/assets/images/arrow-h-light.png"
              alt="#"
              v-if="theme == 'light'"/>
            </div>
            <div class="togglers">
              <lang-toggler-v3></lang-toggler-v3>
              <theme-toggler-v3></theme-toggler-v3>
            </div>
            
           
            
          </div>
        </div>
      </div>

      <div class="tiles-wrapper">
        <div class="tiles tile-1"  @click="navigate('/project-list')">
          <div class="tile-icon-wrapper">
            <img src="@/assets/images/icons/frame.svg" alt="#" />
          </div>
          <span v-if="lang == 'ar'" class="tile-title">لوحة المشاريع</span>
          <span  v-if="lang == 'en'" class="tile-title">Project Dashboards</span>
        </div>

        <div class="tiles tile-2"  @click="navigate('/dashv3')">
          <div class="tile-icon-wrapper">
            <img src="@/assets/images/icons/graphs.svg" alt="#" />
          </div>
          <span v-if="lang == 'en'" class="tile-title">Strategic Dashboard</span>
            <span v-if="lang == 'ar'" class="tile-title">لوحة أداء المشاریع الإستراتیجیة</span>
        </div>

        <div class="tiles tile-3" @click="navigate('/executive')">
          <div class="tile-icon-wrapper">
            <img src="@/assets/images/icons/executive.svg" alt="#" />
          </div>
          <span v-if="lang == 'en'" class="tile-title">Executive Dashboard</span>
           <span v-if="lang == 'ar'" class="tile-title">لوحة أداء الإدارة العليا</span>
        </div>
      </div>

      <div
        class="tiles-wrapper"
        style="justify-content: space-between; margin-top: 40px;"
      >
        <div class="tiles"  @click="navigate('/dt')">
          <div class="tile-icon-wrapper">
            <img src="@/assets/images/icons/globe.svg" alt="#" />
          </div>
          <span v-if="lang == 'en'" class="tile-title">Digital Transformation</span>
           <span v-if="lang == 'ar'" class="tile-title">لوحة أداء المشاریع التحول الرقمي</span>
        </div>

        <div class="tiles"  @click="navigate('/sectors')">
          <div class="tile-icon-wrapper">
            <img src="@/assets/images/icons/pies.svg" alt="#" />
          </div>
          <span v-if="lang == 'en'" class="tile-title">Sector Dashboards</span>
           <span v-if="lang == 'ar'" class="tile-title">لوحة أداء القطاع</span>
        </div>

        <div class="tiles"  @click="navigate('/executive-summary')">
          <div class="tile-icon-wrapper">
            <img src="@/assets/images/icons/executi.svg" alt="#" />
          </div>
          <span v-if="lang == 'en'" class="tile-title">Executive Summary</span>
           <span v-if="lang == 'ar'" class="tile-title">ملخص تنفيذي</span>
        </div>

        <div class="tiles"  @click="navigate('transformation-projects')">
          <div class="tile-icon-wrapper">
            <img src="@/assets/images/icons/executi.svg" alt="#" />
          </div>
          <span v-if="lang == 'en'" class="tile-title">National Transformation Projects</span>
           <span v-if="lang == 'ar'" class="tile-title">لوحة أداء المشاریع التحول الوطني</span>
        </div>
      </div>

    </div>

    <Footer />
  </div>
</template>





<script>
import store from "@/store";
import router from "@/router";

// import Swal from 'sweetalert2'
import axios from "axios"; //uncomment when using api
import ThemeTogglerV3 from "@/components/theme-toggler-v3.vue";
import LangTogglerV3 from "@/components/lang-toggler-v3.vue";
import Footer from "@/components/footer.vue";



// import $ from 'jquery';

// Local data fetch for testign
import { projects } from "@/static/projectdataset.js";
import { risks } from "@/static/riskprojects.js";

export default {
  name: "Sectors-dev",
  components: {
    ThemeTogglerV3,
    LangTogglerV3,
    Footer
  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
    env() {
      return store.getters.getEnv;
    },
  },
  data() {
    return {
      isLoader: false,
      projectData: {
        risks: [],
        projects: [],
        projectSector: {
          isData: false,
          totalSectors: 0,
          labels: [],
        },
      },
    };
  },
  methods: {
    navigate: function (page) {
      router.push(page);
    },
    calculateProjectSector: function () {
      const uniques = this.projectData.projects
        .map((item) => item.ProjectSector)
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.projectData.projectSector.labels.push(feed);
      }
    },
  },
  async mounted() {
    // Fetching from api uncomment below three lines if using api
    if (this.env == "prod") {
      try {
        this.isLoader = true;
        const response = await axios.get(
          "https://pmoapi.sdb.gov.sa/api/proj/3",
          { withCredentials: true }
        );
        this.projectData.projects = JSON.parse(response.data[0]);
        //this.projectData.risks = JSON.parse(response.data[1]);
        this.isLoader = false;
      } catch (error) {
        console.log(error);
      }
    }
    if (this.env == "dev") {
      // Fetching from local comment below three lines if using api
      this.projectData.projects = projects;
      this.projectData.risks = risks;
    }

    this.calculateProjectSector();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/global.scss";

body.ar {
  direction: rtl;
}
body.en {
  direction: ltr;
}

body.theme-light {
  background: $primary-background-light-v3;
}
body.theme-dark {
  background: $primary-background-dark-v3;
}
body.theme-medium {
  background: $primary-background-medium-v3;
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
@import "@/assets/css/common.scss";

body.theme-dark.ar {
  .tiles-wrapper {
    display: flex;
    justify-content: space-between;
    width: 900px;
    margin-top: 124px;

    .tiles {
      width: 198px;
      height: 198px;
      background: rgba(255, 255, 255, 0.02);
      box-shadow: 0px 19px 92px rgba(0, 0, 0, 0.4);
      padding: 20px;
      border-radius: 0px 0px 13px 13px;
      cursor: pointer;
      text-align:center;
      //   margin-left: 198px;

      .tile-icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 97px;
        height: 97px;
        border-radius: 50%;
        margin: auto;
        background: #14354f;
      }

      .tile-title {
        display: block;
        margin-top: 23px;
        @include apply-font(
          $almarai,
          400,
          16px,
          $primary-background-light
        );
      }
    }

    .tile-1 {
      border-radius: 13px 13px 13px 0px;
    }

    .tile-2 {
      border-radius: 13px 13px 0px 0px;
    }
    .tile-3 {
      border-radius: 13px 13px 0px 13px;
    }
  }

  .dashboard-image {
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
body.theme-medium.ar {
  .tiles-wrapper {
    display: flex;
    justify-content: space-between;
    width: 900px;
    margin-top: 124px;

    .tiles {
      width: 198px;
      height: 198px;
      background: linear-gradient(152.47deg, #f2fdff 0.74%, #b2d3da 97.97%);
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      border-radius: 0px 0px 13px 13px;
      padding: 20px;
      cursor: pointer;
      text-align:center;
      //   margin-left: 198px;

      .tile-icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 97px;
        height: 97px;
        border-radius: 50%;
        margin: auto;
        background: #c4e0e6;
      }

      .tile-title {
        display: block;
        margin-top: 23px;
        @include apply-font($almarai, 400, 16px, $v3-dark-header-color);
      }
    }
    .tile-1 {
      border-radius: 13px 13px 13px 0px;
    }

    .tile-2 {
      border-radius: 13px 13px 0px 0px;
    }
    .tile-3 {
      border-radius: 13px 13px 0px 13px;
    }
  }
  .dashboard-image {
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
body.theme-light.ar {
  .tiles-wrapper {
    display: flex;
    justify-content: space-between;
    width: 900px;
    margin-top: 124px;

    .tiles {
      width: 198px;
      height: 198px;
      background: linear-gradient(105.14deg, #f9f9f9 21.3%, #ffffff 78.7%);
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
      border-radius: 0px 0px 13px 13px;
      border: 1px solid #ededed;
      padding: 20px;
      cursor: pointer;
      text-align:center;
      //   margin-left: 198px;

      .tile-icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 97px;
        height: 97px;
        border-radius: 50%;
        margin: auto;
        background: #f1f1f1;
      }

      .tile-title {
        display: block;
        margin-top: 23px;
        @include apply-font($almarai, 400, 16px, $v3-dark-header-color);
      }
    }
    .tile-1 {
      border-radius: 13px 13px 13px 0px;
    }

    .tile-2 {
      border-radius: 13px 13px 0px 0px;
    }
    .tile-3 {
      border-radius: 13px 13px 0px 13px;
    }
  }
  .dashboard-image {
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

body.theme-dark.en {
  .tiles-wrapper {
    display: flex;
    justify-content: space-between;
    width: 900px;
    margin-top: 124px;

    .tiles {
      width: 198px;
      height: 198px;
      background: rgba(255, 255, 255, 0.02);
      box-shadow: 0px 19px 92px rgba(0, 0, 0, 0.4);
      padding: 20px;
      border-radius: 0px 0px 13px 13px;
      cursor: pointer;
      text-align:center;
      //   margin-left: 198px;

      .tile-icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 97px;
        height: 97px;
        border-radius: 50%;
        margin: auto;
        background: #14354f;
      }

      .tile-title {
        display: block;
        margin-top: 23px;
        @include apply-font(
          $sourcesanspro,
          400,
          16px,
          $primary-background-light
        );
      }
    }
    .tile-1 {
      border-radius: 13px 13px 0px 13px;
    }

    .tile-2 {
      border-radius: 13px 13px 0px 0px;
    }
    .tile-3 {
      border-radius: 13px 13px 13px 0px;
    }
  }

  .dashboard-image {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
body.theme-medium.en {
  .tiles-wrapper {
    display: flex;
    justify-content: space-between;
    width: 900px;
    margin-top: 124px;

    .tiles {
      width: 198px;
      height: 198px;
      background: linear-gradient(152.47deg, #f2fdff 0.74%, #b2d3da 97.97%);
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      border-radius: 0px 0px 13px 13px;
      padding: 20px;
      cursor: pointer;
      text-align:center;
      //   margin-left: 198px;

      .tile-icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 97px;
        height: 97px;
        border-radius: 50%;
        margin: auto;
        background: #c4e0e6;
      }

      .tile-title {
        display: block;
        margin-top: 23px;
        @include apply-font($sourcesanspro, 400, 16px, $v3-dark-header-color);
      }
    }
    .tile-1 {
      border-radius: 13px 13px 0px 13px;
    }

    .tile-2 {
      border-radius: 13px 13px 0px 0px;
    }
    .tile-3 {
      border-radius: 13px 13px 13px 0px;
    }
  }

  .dashboard-image {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
body.theme-light.en {
  .tiles-wrapper {
    display: flex;
    justify-content: space-between;
    width: 900px;
    margin-top: 124px;

    .tiles {
      width: 198px;
      height: 198px;
      background: linear-gradient(105.14deg, #f9f9f9 21.3%, #ffffff 78.7%);
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
      border-radius: 0px 0px 13px 13px;
      padding: 20px;
      border: 1px solid #ededed;
      cursor: pointer;
      text-align:center;
      //   margin-left: 198px;

      .tile-icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 97px;
        height: 97px;
        border-radius: 50%;
        margin: auto;
        background: #f1f1f1;
      }

      .tile-title {
        display: block;
        margin-top: 23px;
        @include apply-font($sourcesanspro, 400, 16px, $v3-dark-header-color);
      }
    }
    .tile-1 {
      border-radius: 13px 13px 0px 13px;
    }

    .tile-2 {
      border-radius: 13px 13px 0px 0px;
    }
    .tile-3 {
      border-radius: 13px 13px 13px 0px;
    }
  }

  .dashboard-image {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>
